import React, { useState } from 'react';
import { useAuthStore } from '../../../stores/authStore';
import { useNavigate, Link } from 'react-router-dom';


export const LoginForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login, isLoading, error } = useAuthStore();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await login({ email, password });
            navigate('/');
        } catch (err) {
            // Error handled in store
        }
    };

    return (
        <div className="w-full max-w-md p-8 glass rounded-2xl shadow-xl animate-fade-in">
            <div className="mb-8 text-center">
                <h1 className="text-3xl font-medium bg-clip-text text-transparent bg-gradient-to-r from-accent-primary to-orange-600">
                    Admin Login
                </h1>
                <p className="text-neutral-500 mt-2">Sign in to manage Dashbal</p>
            </div>

            {error && (
                <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded animate-slide-in">
                    <p className="font-medium">Error</p>
                    <p className="text-sm">{error}</p>
                </div>
            )}

            <form 
                id="dashbal-admin-login-form" 
                name="dashbal-admin-login-form" 
                onSubmit={handleSubmit} 
                className="space-y-6"
            >
                <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-1">
                        Email Address
                    </label>
                    <input
                        type="email"
                        name="admin_email"
                        autoComplete="username"
                        required
                        className="input w-full focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all"
                        placeholder="admin@dashbal.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <div>
                    <div className="flex justify-between items-center mb-1">
                        <label className="block text-sm font-medium text-neutral-700">
                            Password
                        </label>
                        <Link to="/forgot-password" className="text-sm text-accent-primary hover:text-orange-700 transition-colors">
                            Forgot password?
                        </Link>
                    </div>

                    <input
                        type="password"
                        name="admin_password"
                        autoComplete="current-password"
                        required
                        className="input w-full focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full btn-primary py-3 rounded-lg text-white font-semibold transform hover:scale-[1.02] transition-all disabled:opacity-50 disabled:hover:scale-100 shadow-lg shadow-accent-primary/20"
                >
                    {isLoading ? (
                        <div className="flex items-center space-x-2">
                            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            <span>Signing in...</span>
                        </div>
                    ) : (
                        'Sign In'
                    )}
                </button>
            </form>
        </div>
    );
};
